import { handleApiRequest } from '../services/transports';
import { userModel } from '../constants';

import { REACT_APP_RSD_DOMAIN } from './base';

export const searchUsers = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/user-stakeholder-search`,
  method: 'get',
  query
});
export const editMpUserStakeholder = username => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/edit-mp-user-stakeholder/${username}`,
  method: 'get'
});

export const sopViewProfile = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-view-profile`,
  method: 'get',
  query
});

export const smpViewProfile = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/smp-view-profile`,
  method: 'get',
  query
});


export const newUser = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-ssn-stakeholder-user`,
  method: 'post',
  data
});

export const searchStakeholders = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/stakeholder-stakeholder-search`,
  method: 'get',
  query
});

export const resetPassword = UserName => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-reset-user-password/${UserName}`,
  method: 'post'
});

export const updateProfile = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/sop-update-profile`,
  method: 'put',
  data
});

export const SMPupdateProfile = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/smp-profile-update-password`,
  method: 'post',
  data
});


export const updateStatus = data => handleApiRequest({
  // eslint-disable-next-line max-len
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/mp-activate-deactivate-user/${data[userModel.USER_ACTIVATION.USERNAME]}`,
  method: 'put',
  data
});

export const userHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/user-stakeholder-history`,
  method: 'get',
  query
});

export const stakeholderHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/stakeholder-stakeholder-history`,
  method: 'get',
  query
});


export const SerachByGLN = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/new-mp-user-stakeholder/${query.gln}`,
  method: 'get'
});

export const newUserForSH = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-usn-stakeholder-user`,
  method: 'post',
  data
});

export const searchStakeholderRequests = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/stakeholder-request-search`,
  method: 'get',
  query
});

export const requestHistory = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/stakeholder-request-history`,
  method: 'get',
  query
});

export const editUser = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-use-stakeholder-user`,
  method: 'put',
  data
});

export const stakeholderPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-sse-stakeholder-user-service-privileges`,
  method: 'get',
  query
});

export const sopPortalPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/sop-stakeholder-user-portal-privileges`,
  method: 'get',
  query
});
export const mpPortalPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-stakeholder-user-portal-privileges`,
  method: 'get',
  query
});

export const editRequest = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-ssre-stakeholder-user`,
  method: 'put',
  data
});

export const getSHRequest = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/edit-mp-stakeholder-request/${query.id}`,
  method: 'get'
});

export const getDefaultPrivileges = id => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/stakeholder-default-privileges/${id}`,
  method: 'get'
});

export const searchShortage = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}drug-service/api/portal/DrugShortage/drug-shortage-list`,
  method: 'get',
  query
});

export const searchStakeholderUsers = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Utility/list-stakeholder-users/${query.shId}`,
  method: 'get'
});

export const userManamgementSearchMedicalEstablishmentDrugShortage = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}demand-and-offer-service/api/portal/DemandShortage/assignto-demand-shortage`,
  method: 'get',
  query
});


export const userManamgementSearch = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/assignedto-user-manamgement-search`,
  method: 'get',
  query
});


export const getStakeholder = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/UserActions/edit-mp-stakeholder-stakeholder/${query.gln}`,
  method: 'get'
});

export const editStakeholder = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-sse-stakeholder-user`,
  method: 'put',
  data
});

export const getUserPrivileges = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Utility/service-privileges-by-username`,
  method: 'get',
  query
});

export const smpStakeholderRequests = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/QueryUsers/smp-stakeholder-request-search`,
  method: 'get',
  query
});

export const newSHReq = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/smp-stakeholder-request-add`,
  method: 'post',
  data
});

export const rejectRequest = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/Portal/Register/mp-ssre-reject-stakeholder-user`,
  method: 'put',
  form
});

export const returnRequest = form => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/Portal/Register/mp-ssre-return-stakeholder-user`,
  method: 'put',
  form
});

export const approveRequest = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/Portal/Register/mp-ssre-stakeholder-user`,
  method: 'put',
  data
});
